module.exports = __webpack_public_path__ + "media/images/iconTrendDown__inactive--dark-1faf8643383690bd39a58b7db20f22c2.png";